import 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { Layout } from 'antd'

import { NavbarDesign, TopFilters } from '../../components'

// import { ThemeContext } from '../../providers'

// import logoWhite from '../../assets/hearful-logo-green.svg'
// import logoBlue from '../../assets/hearful-logo.svg'

const { Content } = Layout

export const FiltersLayout = () => {
  // const { theme } = useContext(ThemeContext)
  const { pathname } = useLocation()
  // const [collapsed, setCollapsed] = useState(false)

  // useEffect(() => {
  //   // Perform side effect when location changes
  //   console.log('Location changed to:', pathname)

  //   // Cleanup function to prevent memory leaks
  //   return () => {
  //     console.log('Component is unmounting or location is changing')
  //     // Perform cleanup actions, such as canceling subscriptions or clearing intervals
  //   }
  // }, [pathname])

  // const toggleCollapsed = () => {
  //   setCollapsed(!collapsed)
  // }

  return (
    <>
      <NavbarDesign />
      <Content className="page-container">
        <Layout className="site-layout-background">
          <Layout className="site-layout">
            {pathname !== '/settings' ? <TopFilters /> : null}
            <Outlet />
          </Layout>
        </Layout>
      </Content>
    </>
  )
}
